/**
 * SignalR Service - Centralized exports
 * Tập trung tất cả SignalR functionality vào một chỗ duy nhất
 */

export { signalRService, default } from './SignalRService';
export type { SignalRNotificationMessage, ThreadEventData, CommentEventData } from './SignalRService';
export { registerRealtimeHandlers, unregisterRealtimeHandlers } from './RegisterHandlers';

